import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PlaceNewPolicy = lazy(() => import('@pages/producer/PlaceNewPolicy'));

const PlaceNewPolicyRoutes: RouteObject[] = [
  {
    path: '/place-new-policy',
    element: (
      <React.Suspense>
        <PlaceNewPolicy />
      </React.Suspense>
    ),
    children: [],
  },
];

export default PlaceNewPolicyRoutes;